import { Calendar, EditOne, FileWithdrawal, PeopleSpeak } from '@icon-park/react';
import type { ReactElement } from 'react';

export enum ASSIGNMENT_STEPS {
  // Default
  SUBMITTED = 'SUBMITTED',
  CORRECTED = 'CORRECTED',

  // Oral
  APPOINTMENT_SCHEDULED = 'APPOINTMENT_SCHEDULED',
  ORAL_DONE = 'ORAL_DONE',
}

export const ASSIGNMENT_STEP_ICONS_MAP: Record<ASSIGNMENT_STEPS, ReactElement> = {
  [ASSIGNMENT_STEPS.SUBMITTED]: <EditOne />,
  [ASSIGNMENT_STEPS.CORRECTED]: <FileWithdrawal />,

  [ASSIGNMENT_STEPS.APPOINTMENT_SCHEDULED]: <Calendar />,
  [ASSIGNMENT_STEPS.ORAL_DONE]: <PeopleSpeak />,
};
